import { Validator } from 'vee-validate';

Validator.extend('login_id', {
    getMessage: field => field + 'の形式は正しくありません。',
    validate: value => /^[A-Za-z0-9_.-]+$/.test(value)
});
Validator.extend('override-email', {
    getMessage: field => field + 'の形式は正しくありません。',
    validate: value => /^[A-Za-z0-9!#$%&'*+-/=?^_`{|}~.@]+$/.test(value)
});
Validator.extend('override_email', {
    getMessage: field => field + 'の形式は正しくありません。',
    validate: value => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
});
Validator.extend('unique_email', {
    getMessage: field => field + '設定されました。',
    validate: (value, { index, listEmail }) => {
        const duplicates = listEmail.filter((item, i) => item === value && i !== index);
        return duplicates.length === 0;
    },
    params: ['index', 'listEmail'],
});
Validator.extend('folder_name', {
    getMessage: field => field + " !#$%&'*+/=?^`{|}~@ を入力しないでください。",
    validate: value => /^[^!#$%&'*+/=?^`{|}~@]+$/.test(value)
});
Validator.extend('port', {
    getMessage: field => field + '形式が正しくありません。',
    validate: value =>/^[0-9]+$/.test(value)
});
Validator.extend('mail-domain',{
    getMessage: field => field + 'の形式が正しくありません。',
    validate: value => /^@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.test(value),
})
Validator.extend('maxfilesize', {
    validate: (value, args) => {
        const maxValue = args[0];
        return Number(value) > 0 && Number(value) <= Number(maxValue);
    },
    getMessage: (field, args) => {
        const maxValue = args[0];
        return '数値は1から'+maxValue+'まで入力してください。';
    }
});
export default{}